function animatePageOut() {
  function addBodyClass() {
    document.body.classList.add("js-animate-out");
  }

  function timeOutClick(e) {
    e.preventDefault();

    const goToLink = this.getAttribute("href");

    setTimeout(() => {
      window.location.href = goToLink;
    }, 600);
  }

  const menuItems = [...document.querySelectorAll(".single .primary-nav a")];
  const innerLinks = [...document.querySelectorAll(".page-fadeout")];

  const mainLogo = document.querySelector(".main-logo-wrap");

  menuItems.forEach((menuItem) =>
    menuItem.addEventListener("click", addBodyClass)
  );

  menuItems.forEach((menuItem) =>
    menuItem.addEventListener("click", timeOutClick)
  );

  innerLinks.forEach((innerLink) =>
    innerLink.addEventListener("click", addBodyClass)
  );

  innerLinks.forEach((innerLink) =>
    innerLink.addEventListener("click", timeOutClick)
  );

  mainLogo.addEventListener("click", addBodyClass);
  mainLogo.addEventListener("click", timeOutClick);
}

export { animatePageOut };
